import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import InappropriateUseCard from './InappropriateUseCard/InappropriateUseCard';
import './_inappropriate-use-section.scss';
import useInappropriateUseSection from './useInappropriateUseSection';

type InappropriateUseSectionProps = {
  allCourseIds: string[];
  classValue: string;
  groupCourseMap: Record<string, string[]>;
  timePeriodValue: string;
};

function InappropriateUseSection({ allCourseIds, classValue, groupCourseMap, timePeriodValue }: InappropriateUseSectionProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const history = useHistory();
  const { messages, total, loading } = useInappropriateUseSection({
    allCourseIds,
    classValue,
    groupCourseMap,
    timePeriodValue,
  });

  if (loading || total === 0) {
    return null;
  }

  return (
    <div className="inappropriate-use-section">
      <div className="inappropriate-use-section__header">
        <div className="inappropriate-use-section__header-titles">
          <h2 className="inappropriate-use-section__title">{t('chatbot:ai_analytics_inappropriate_use_title')}</h2>
          <p className="inappropriate-use-section__subtitle">{t('chatbot:ai_analytics_inappropriate_use_subtitle', { count: total })}</p>
        </div>
        {total > 0 && (
          <div className="inappropriate-use-section__header-actions">
            <button className="inappropriate-use-section__mark-all-btn" disabled type="button">
              {t('chatbot:ai_analytics_inappropriate_use_mark_all')}
            </button>
            <button
              className="inappropriate-use-section__view-all-btn"
              onClick={() => history.push(`/analytics/flagged-messages?class=${classValue}&period=${timePeriodValue}`)}
              type="button"
            >
              {t('chatbot:ai_analytics_inappropriate_use_view_all', { count: total })}
            </button>
          </div>
        )}
      </div>

      {messages.length > 0 && (
        <div className="inappropriate-use-section__cards">
          {messages.map((message) => (
            <InappropriateUseCard key={message.annotationId} message={message} />
          ))}
        </div>
      )}
    </div>
  );
}

export default InappropriateUseSection;
